export const ua = {
  title: 'Вихідні дані (Impressum)',
  subtitle: 'Обовʼязкові відомості згідно з Регламентом ЄС 2018/302 та естонським Комерційним кодексом (äriseadustik) · Станом на: 10.05.2026',
  sections: [
    {
      id: 'company',
      title: 'Постачальник послуг',
      body:
        '**MATTALNET GRUPP OÜ**\nTuukri tn 19-315\n10120 Tallinn, Естонія (Estonia)\n\n- **Registrikood (реєстраційний номер у торговому реєстрі):** 14744075\n- **Ідент. номер платника ПДВ / KMKR number:** EE102519059\n- **EORI:** EE14744075\n- **D-U-N-S:** 536415812\n- **Реєстр:** Eesti äriregister (Естонський торговий реєстр)\n- **Організаційно-правова форма:** Osaühing (OÜ) — товариство з обмеженою відповідальністю згідно з естонським правом\n- **Має дозвіл та регулюється в:** Естонській Республіці, Європейському Союзі',
    },
    {
      id: 'responsible',
      title: 'Відповідальний за зміст',
      body:
        '**Andreas A. Gleim**\nКерівник / відповідальний за зміст згідно з естонським Комерційним кодексом (äriseadustik) та § 18 MStV (Німеччина)\n\nЕлектронна пошта: [logixa.one/kontakt](/kontakt)',
    },
    {
      id: 'contact',
      title: 'Контакти',
      body:
        'Електронна пошта: [logixa.one/kontakt](/kontakt)\nВебсайт: [https://logixa.one](https://logixa.one)\n\nЗапити щодо платформи, партнерства, преси та захисту даних надсилайте на зазначену вище адресу електронної пошти або через [контактну форму](/kontakt).',
    },
    {
      id: 'eu',
      title: 'Вирішення спорів у ЄС',
      body:
        'Європейська Комісія надає платформу для онлайн-вирішення спорів (OS):\n\n[https://ec.europa.eu/consumers/odr/](https://ec.europa.eu/consumers/odr/)\n\nМи не зобовʼязані та не маємо наміру брати участь у процедурі вирішення спорів перед органом з врегулювання споживчих спорів.',
    },
    {
      id: 'liability',
      title: 'Відповідальність за зміст',
      body:
        'Як постачальник послуг ми несемо відповідальність за власний контент на цих сторінках згідно із загальними законами відповідно до § 7 абз. 1 TMG (Німеччина) та естонського InfoTS. Однак згідно з §§ 8–10 TMG ми як постачальник послуг не зобовʼязані контролювати передану або збережену чужу інформацію.\n\nЗобовʼязання щодо видалення або блокування використання інформації згідно із загальними законами залишаються незмінними. Однак відповідна відповідальність можлива лише з моменту, коли стає відомо про конкретне правопорушення.',
    },
    {
      id: 'liability-links',
      title: 'Відповідальність за посилання',
      body:
        'Наша пропозиція містить посилання на зовнішні вебсайти третіх осіб, на зміст яких ми не маємо впливу. Тому ми не можемо нести відповідальність за цей чужий контент. За зміст сторінок, на які ведуть посилання, завжди відповідає відповідний постачальник або оператор цих сторінок.',
    },
    {
      id: 'copyright',
      title: 'Авторське право',
      body:
        'Контент і твори на цих сторінках, створені операторами сайту, охороняються авторським правом. Відтворення, опрацювання, поширення та будь-який вид використання за межами авторського права потребують письмової згоди відповідного автора чи укладача.\n\nЗавантаження та копіювання цієї сторінки дозволені лише для приватного, некомерційного використання.',
    },
  ],
};
